type ObjType = {
    [key: string]: {
        [key: string]: string[];
    };
};

export const obj: ObjType = {
    images: {
        orientation: ['All', 'Horizontal', 'Vertical'],
        category: [
            'All',
            'Fashion',
            'Nature',
            'Backgrounds',
            'Science',
            'Education',
            'Feelings',
            'Health',
            'People',
            'Religion',
            'Places',
            'Animals',
            'Industry',
            'Computer',
            'Food',
            'Sports',
            'Transportation',
            'Travel',
            'Buildings',
            'Business',
            'Music',
        ],
        colors: [
            'All',
            'Grayscale',
            'Transparent',
            'Red',
            'Orange',
            'Yellow',
            'Green',
            'Turquoise',
            'Blue',
            'Lilac',
            'Pink',
            'White',
            'Gray',
            'Black',
            'Brown',
        ],
        order: ['All', 'Popular', 'Latest'],
    },
    videos: {
        video_type: ['All', 'Film', 'Animation'],
        category: [
            'All',
            'Backgrounds',
            'Fashion',
            'Nature',
            'Science',
            'Education',
            'Feelings',
            'Health',
            'People',
            'Religion',
            'Places',
            'Animals',
            'Industry',
            'Computer',
            'Food',
            'Sports',
            'Transportation',
            'Travel',
            'Buildings',
            'Business',
            'Music',
        ],
        order: ['All', 'Popular', 'Latest'],
    },
};
